<template>
  <div class="product-detail-page">
    <div class="box">

      <div class="detail-hero">
        <div class="hero-image-gallery">
          <div class="main-image-display">
            <img :src="mainImage" :alt="product.name" />
          </div>
          <div class="thumbnail-gallery">
            <img
                v-for="(img, index) in product.images"
                :key="index"
                :src="img"
                :alt="`Thumbnail ${index + 1}`"
                :class="{ active: mainImage === img }"
                @click="mainImage = img"
            />
          </div>
        </div>

        <div class="hero-info">
          <h1 class="product-name">{{ product.name }}</h1>
          <p class="product-model">型号: {{ model }}</p>

          <div class="key-features">
            <h3>主要特点</h3>
            <div class="text-content" v-html="overviewHtml"></div>
          </div>

        </div>
      </div>

      <div class="detail-tabs-section">
        <div class="tabs-nav">
          <button
              v-for="tab in tabs"
              :key="tab.id"
              :class="{ active: activeTab === tab.id }"
              @click="activeTab = tab.id"
          >
            {{ tab.name }}
          </button>
        </div>

        <div class="tab-content">
          <div v-if="activeTab === 'overview'" class="content-block">
            <div v-html="fullDescription"></div>
          </div>

          <div v-if="activeTab === 'parameters'" class="content-block">
            <table class="parameters-table">
              <thead>
              <tr>
                <th>参数名称</th>
                <th>数值</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(value, key) in parameters" :key="key">
                <td>{{ key }}</td>
                <td>{{ value }}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div v-if="activeTab === 'applications'" class="content-block">
            <div v-html="applicationsHtml" class="application-list"></div>
          </div>

          <div v-if="activeTab === 'resources'" class="content-block">
            <div v-html="relatedMaterialsHtml"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDetail',
  props: {
    // Receive product data as a prop
    product: {
      type: Object,
      required: true,
      default: () => ({
        id: '',
        name: '未知产品',
        model: 'N/A',
        images: [],
        features: [],
        shortDescription: '产品概述缺失。',
        fullDescription: '详细描述缺失。',
        parameters: {},
        applications: [],
      }),
    },
  },
  data() {
    return {
      mainImage: '', // The currently displayed large image
      activeTab: 'overview', // Default active tab
      shortDescription: '', // Derived from product.overview
      fullDescription: '', // Derived from product.overview
      parameters: {}, // Derived from product.technical_parameters
      applicationsHtml: '', // Derived from product.application_fields (HTML string)
      relatedMaterialsHtml: '', // Derived from product.related_materials (HTML string)
      applicationScenariosHtml: '', // Derived from product.application_scenarios (HTML string)
      model: '', // Derived from product.product_code
      tabs: [
        { id: 'overview', name: '产品概述' },
        { id: 'parameters', name: '技术参数' },
        { id: 'applications', name: '应用领域' },
        // { id: 'resources', name: '相关资料' },
      ],
    };
  },
  watch: {
    // When product prop changes, update mainImage and other derived properties
    product: {
      immediate: true, // Run immediately on component mount and on product prop changes
      handler(newProduct) {
        if (newProduct) {
          // Set mainImage from the combined images array
          this.mainImage = newProduct.images && newProduct.images.length > 0
            ? newProduct.images[0]
            : '/public/images/no-bg.jpg'; // Fallback image

          // Map API data to component's internal data structure
          this.shortDescription = newProduct.application_fields || '产品概述缺失。';
          this.fullDescription = newProduct.overview || '详细描述缺失。';
          this.parameters = newProduct.technical_parameters || {};
          this.overviewHtml = newProduct.application_scenarios || '';
          this.applicationsHtml = newProduct.application_fields || '';
          this.relatedMaterialsHtml = newProduct.related_materials || '';
          this.applicationScenariosHtml = newProduct.application_scenarios || '';
          this.model = newProduct.model || 'N/A';

          console.log(this.model)
        }
      },
    },
  },
  mounted() {
    // Initial setup for mainImage and other derived properties when component is mounted
    if (this.product) {
      this.mainImage = this.product.images && this.product.images.length > 0
        ? this.product.images[0]
        : '/public/images/no-bg.jpg'; // Fallback image

      this.shortDescription = this.product.technical_parameters || '产品概述缺失。';
      this.fullDescription = this.product.overview || '详细描述缺失。';
      this.parameters = this.product.technical_parameters || {};
      this.applicationsHtml = this.product.application_fields || '';
      this.relatedMaterialsHtml = this.product.related_materials || '';
      this.applicationScenariosHtml = this.product.application_scenarios || '';
      this.model = this.product.model || 'N/A';
    }
  }
};
</script>

<style scoped>
.product-detail-page {
  padding: 0px 0;
  background-color: #f8f9fa;
}

.box {
  max-width: 1200px;
  margin: 0 auto;
}

/* Back Button */
.back-link-wrapper {
  margin-bottom: 30px;
  text-align: left;
}
.back-btn {
  background-color: #6c757d; /* Grey button for contrast */
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 15px;
  transition: background-color 0.3s ease, transform 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.back-btn:hover {
  background-color: #5a6268;
  transform: translateY(-2px);
}

/* Hero Section */
.detail-hero {
  display: flex;
  gap: 40px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  padding: 30px;
  margin-bottom: 50px;
}

.hero-image-gallery {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.main-image-display {
  background-color: #f0f8f4; /* Light green background */
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 450px; /* Fixed height for main image area */
  overflow: hidden; /* Ensure image fits */
}
.main-image-display img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* Contain the image within the area */
}
.thumbnail-gallery {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.thumbnail-gallery img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.thumbnail-gallery img.active,
.thumbnail-gallery img:hover {
  border-color: #47975a;
  transform: translateY(-2px);
}

.hero-info {
  flex: 1;
  padding: 10px 0;
}
.product-name {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}
.product-model {
  font-size: 18px;
  color: #6c757d;
  margin-bottom: 25px;
  font-weight: 500;
}

.key-features {
  margin-bottom: 30px;
}
.key-features h3 {
  font-size: 20px;
  color: #47975a;
  margin-bottom: 15px;
  position: relative;
  padding-left: 15px;
}
.key-features h3::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
  height: 20px;
  background-color: #47975a;
  border-radius: 2px;
}
.key-features ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.key-features li {
  font-size: 16px;
  color: #555;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
}
.feature-icon {
  color: #47975a;
  margin-right: 10px;
  font-weight: bold;
}

.short-description {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 30px;
}

.contact-action {
  text-align: center;
}
.inquiry-btn {
  background: #47975a;
  color: #fff;
  border: none;
  padding: 15px 40px;
  border-radius: 30px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(71, 151, 90, 0.3);
}
.inquiry-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(71, 151, 90, 0.4);
}

/* Detail Tabs Section */
.detail-tabs-section {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  padding: 30px;
  margin-bottom: 50px;
}
.tabs-nav {
  display: flex;
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 30px;
}
.tabs-nav button {
  background-color: transparent;
  border: none;
  padding: 15px 25px;
  font-size: 18px;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  font-weight: 500;
}
.tabs-nav button:hover {
  color: #47975a;
}
.tabs-nav button.active {
  color: #47975a;
  font-weight: 600;
}
.tabs-nav button.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #47975a;
}

.tab-content {
}
.content-block h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
}
.content-block :deep(p) {
  font-size: 16px;
  line-height: 1.8;
  color: #555;
  margin-bottom: 1.5em;
}

.text-content :deep(p) {
  margin-bottom: 0.8em;
}

/* Parameters Table */
.parameters-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  font-size: 15px;
}
.parameters-table th,
.parameters-table td {
  border: 1px solid #e9ecef;
  padding: 12px 15px;
  text-align: left;
}
.parameters-table th {
  background-color: #f0f8f4;
  color: #47975a;
  font-weight: 600;
}
.parameters-table tr:nth-child(even) {
  background-color: #fdfdfd;
}

/* Application List */
.application-list {
  list-style: disc; /* Use default disc bullet points */
  padding-left: 25px;
  margin-top: 20px;
}
.application-list :deep(p) {
  margin-bottom: 1.5em !important;
  font-size: 16px !important;
  color: #555 !important;
}
.application-list li {
  font-size: 16px !important;
  color: #555 !important;
  margin-bottom: 10px !important;
}

/* Download Links */
.download-link {
  color: #47975a;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
  display: inline-block;
  margin-bottom: 10px;
}
.download-link:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 992px) {
  .detail-hero {
    flex-direction: column;
  }
  .main-image-display {
    height: 350px;
  }
  .hero-info {
    padding: 0;
  }
  .product-name {
    font-size: 30px;
  }
}

@media (max-width: 768px) {
  .main-image-display {
    height: 300px;
  }
  .tabs-nav {
    flex-wrap: wrap;
  }
  .tabs-nav button {
    padding: 12px 15px;
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .product-detail-page {
    padding: 0px 0;
  }
  .detail-hero {
    padding: 20px;
  }
  .product-name {
    font-size: 24px;
  }
  .product-model {
    font-size: 16px;
  }
  .main-image-display {
    height: 250px;
  }
  .thumbnail-gallery img {
    width: 60px;
    height: 60px;
  }
  .text-content{
    font-size: 16px;
  }
  .inquiry-btn {
    padding: 12px 30px;
    font-size: 16px;
  }
  .tabs-nav button {
    padding: 10px 12px;
    font-size: 14px;
  }
  .content-block h3 {
    font-size: 20px;
  }
  .content-block p, .parameters-table, .application-list li {
    font-size: 14px;
  }
}
</style>